var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarketingBannerImage = function SvgMarketingBannerImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 224,
    height: 125
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "marketing-banner-image_svg__a",
    cx: "93.522%",
    cy: "8.681%",
    r: "423.475%",
    fx: "93.522%",
    fy: "8.681%",
    gradientTransform: "matrix(.61741 0 0 1 .358 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "10%",
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "21%",
    stopColor: "#F0F0F0",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "44%",
    stopColor: "#F0F0F0",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76%",
    stopColor: "#F0F0F0",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M107.11 72.841v-.083.083z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.849,
    d: "M129.742 100H48.58a2.766 2.766 0 0 1-2.762-2.765V19.569a2.763 2.763 0 0 1 2.762-2.761h109.99a18.257 18.257 0 0 0 18.284 19.701v25.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 9.391,
    d: "M176.852.023c10.072.054 18.194 8.26 18.144 18.332",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 9.391,
    d: "M176.852.025a18.24 18.24 0 1 0 18.144 18.33"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.699,
    d: "m182.3 12.718-11.09 11.091"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.752,
    cy: 14.262,
    r: 1.762,
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.699
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.758,
    cy: 22.268,
    r: 1.762,
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.699
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.849,
    d: "M79.884 90.545h49.743m-76.689 0h21.759",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.291,
    cy: 90.545,
    r: 2.595,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.849,
    d: "M111.336 48.832a9.572 9.572 0 1 0 0 19.142 9.572 9.572 0 0 0 0-19.143z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.548,
    d: "M45.818 108.778h56.01"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.849,
    d: "M.09 20.584h37.212",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.132,
    d: "M21.201 7.125h13.736",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.849,
    d: "M20.51 29.775h14.427M20.51 42.104h14.427",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M11.986 31.703H6.34a.667.667 0 0 1-.668-.667v-4.645c0-.369.3-.668.668-.668h1.945c.369 0 .668.299.668.668v.615c0 .133.109.24.242.24h2.79c.368 0 .667.3.667.668v3.122a.667.667 0 0 1-.667.667z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.849,
    d: "M1.193 25.328v6.794",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.162,
    cy: 42.104,
    r: 3.494,
    fill: "#FFF",
    fillRule: "nonzero",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.548,
    d: "M20.51 55.232h14.427"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.162,
    cy: 55.232,
    r: 5.975,
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.821
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.821,
    d: "M9.142 55.273a1.273 1.273 0 1 1 1.273-1.274m-1.238 1.274a1.274 1.274 0 0 1 .903 2.172 1.273 1.273 0 0 1-2.174-.899m1.256-4.869v.969m0 5.171v.97"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.162,
    cy: 7.087,
    r: 7.068,
    fill: "#FFF",
    fillRule: "nonzero",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92.95,
    height: 57.388,
    x: 129.744,
    y: 62.009,
    fill: "url(#marketing-banner-image_svg__a)",
    fillRule: "nonzero",
    opacity: 0.7,
    rx: 1.932
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m47.378 114.673.756 1.53 1.689.246-1.222 1.191.289 1.682-1.512-.794-1.51.794.289-1.682-1.223-1.191 1.688-.246zm6.845 0 .756 1.53 1.688.246-1.221 1.191.289 1.682-1.512-.794-1.51.794.289-1.682-1.224-1.191 1.691-.246zm6.845 0 .755 1.53 1.689.246-1.221 1.191.288 1.682-1.511-.794-1.511.794.289-1.682-1.223-1.191 1.69-.246zm6.844 0 .756 1.53 1.69.246-1.223 1.191.289 1.682-1.512-.794-1.51.794.289-1.682-1.222-1.191 1.689-.246zm6.846 0 .755 1.53 1.69.246-1.223 1.191.289 1.682-1.511-.794-1.511.794.288-1.682-1.221-1.191 1.689-.246z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.548,
    d: "M177.054 78.76h36.162"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.849,
    d: "M177.054 85.98h36.162"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.929,
    height: 14.757,
    x: 176.698,
    y: 97.183,
    fill: "#FF755D",
    fillRule: "nonzero",
    rx: 1.959
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.712,
    d: "M181.789 104.561h28.747"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M171.462 69.466h-33.62c-.57 0-1.03.46-1.031 1.03v40.413c0 .569.462 1.03 1.03 1.03h33.621c.57 0 1.03-.461 1.032-1.03V70.495a1.032 1.032 0 0 0-1.032-1.03zm-24.914 20.158a3.377 3.377 0 1 1-.013 6.749 3.377 3.377 0 0 1 .013-6.749zm21.525 17.569h-27v-4.05l3.338-3.337a1.013 1.013 0 0 1 1.432 0l3.337 3.337 10.085-10.083a1.013 1.013 0 0 1 1.432 0l7.376 7.39v6.743z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m115.875 58.848-6.508 3.69a.53.53 0 0 1-.791-.466V54.73a.53.53 0 0 1 .788-.46l6.507 3.657a.527.527 0 0 1 .004.921z",
    opacity: 0.5
  }))));
};
export { SvgMarketingBannerImage as ReactComponent };
export default "data:image/svg+xml;base64,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";